const I = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOSAyYTIgMiAwIDAgMSAyIDJ2MTZhMiAyIDAgMCAxLTIgMkg3YTIgMiAwIDAgMS0yLTJWNGEyIDIgMCAwIDEgMi0yaDJ6bTggMGEyIDIgMCAwIDEgMiAydjE2YTIgMiAwIDAgMS0yIDJoLTJhMiAyIDAgMCAxLTItMlY0YTIgMiAwIDAgMSAyLTJoMnpNOSA0SDd2MTZoMlY0em04IDBoLTJ2MTZoMlY0eiIgIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
export {
  I as default
};
//# sourceMappingURL=pause-8f55678f.mjs.map
